import { render, staticRenderFns } from "./CustomerInconsistences.vue?vue&type=template&id=f51f675a&scoped=true"
import script from "./CustomerInconsistences.vue?vue&type=script&lang=js"
export * from "./CustomerInconsistences.vue?vue&type=script&lang=js"
import style0 from "./CustomerInconsistences.vue?vue&type=style&index=0&id=f51f675a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51f675a",
  null
  
)

export default component.exports